import { SxStyles } from '../../types';
import theme from '../../theme';
import { getResponsiveSize } from '../../utils';

export const SessionCheckDialogStyle: SxStyles = {
  sessionCheckDialogContainer: {
    '& .title-content': {
      fontFamily: theme.typography.mainFontFamily,
      color: theme.palette.mainControls?.activeText,
    },
    '& .main-container': {
      '& .container-text': {
        fontFamily: theme.typography.mainFontFamily,
        fontSize: getResponsiveSize(15.5),
        color: theme.palette.mainControls?.activeText,
      },
    },
    '& .button-settings': {
      color: theme.palette.mainControls?.mainBlue,
    },
    '& .MuiPaper-root': {
      borderRadius: '22px',
    },
  },
};
